/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Own_Bot_Not_InstalledInputs */



/**
* | output |
* | --- |
* | "Your bot isn't in this server yet. Invite it on Discord, then move." |
*
* @param {Settings_Own_Bot_Not_InstalledInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const settings_own_bot_not_installed = /** @type {((inputs?: Settings_Own_Bot_Not_InstalledInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Own_Bot_Not_InstalledInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вашего бота ещё нет на этом сервере. Пригласите его через Discord и повторите переход.")
	return /** @type {LocalizedString} */ ("Your bot isn't in this server yet. Invite it on Discord, then move.")
});